module.exports = __webpack_public_path__ + "static/media/gpsp 23.83b77588.png";